<template>
  <v-container fluid class="px-1 py-1">
    <CommonDetail
        :uid-item="uidItem"
        :store-name="storeName"
        :dto-detail-query="dtoDetailQuery"
        :dto-save-command="dtoSaveCommand"
        :dto-action-command="dtoActionCommand"
        :dto-validate-command="dtoValidateCommand"
        :main-validator="mainValidator"
        :modal-dialog="modalDialog"
        :parent-component="parentComponent"
        :wrap-component="$options.name"
        @close="$emit('close')"
    >
      <template v-slot:body="{height}">
        <v-simple-table dense :height="height - 30" class="px-1">
          <template v-slot:default>
            <thead>
            <tr>
              <th class="text-left">Parameter</th>
              <th class="text-left">Value</th>
              <th class="text-left">Current value</th>
            </tr>
            </thead>
            <tbody>
            <tr
                v-for="[key, value] of Object.entries(storeAggregate.rootData[storeDetail.uidItem].object)"
                :key="key"
            >
              <td>{{ key }}</td>
              <td>{{ value }}</td>
              <td
                  v-if="!!current"
                  :style="value !== current[key] ? { 'color': 'red'} : ''"
              >{{ current[key] }}</td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </template>
    </CommonDetail>
  </v-container>
</template>

<script>
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useDetailStore} from "@/components/Common/CommonDetail";
import CommonDetail from "@/components/Common/CommonDetail";
import BaseFieldText from "@/components/Base/BaseFieldText";

export default {
  name: "CoreChangeLogDetail",

  props: {
    uidItem: {default: null},
    storeName: {type: [String], default: 'ChangeLogDetail'},
    dtoDetailQuery: {default: 'ChangeLogDetailQueryDTO'},
    dtoActionCommand: {type: [String], default: 'ChangeLogActionCommandDTO'},
    dtoSaveCommand: {type: [String], default: 'ChangeLogSaveCommandDTO'},
    dtoValidateCommand: {type: [String], default: 'ChangeLogValidateCommandDTO'},
    dtoModelForValidate: {type: [String], default: 'ChangeLogBaseDTO'},
    mainValidator: {type: [Boolean], default: true},
    modalDialog: {type: [Boolean], default: false},
    parentComponent: {type: [String], default: 'CoreChangeLogTable'},
    routeFullScreen: {type: [Object], default: null},
  },

  components: {
    CommonDetail,
    BaseFieldText,
  },

  computed: {
    current() {
      let object_uid = null
      if (!!this.storeDetail.uidItem && !!this.storeAggregate.rootData[this.storeDetail.uidItem])
        object_uid = this.storeAggregate.rootData[this.storeDetail.uidItem].object_uid
      else
        return
      return this.storeAggregate.rootData[object_uid]
    },
  },

  methods: {},


  mounted() {
    this.storeDetail = useDetailStore(this.storeName)()
    this.storeAggregate = useAggregateStore()
  },

  data() {
    return {
      storeDetail: null,
      storeAggregate: null,
    }
  },
}
</script>

<style scoped>

</style>